import { LazyLoadedStates, LazyLoadedStatesManager } from '@edl-development/edl-common';

export const UsersLazyLoadedStates = new LazyLoadedStatesManager<{
    base: LazyLoadedStates,
    view: LazyLoadedStates,
    viewSearch: LazyLoadedStates,
    bulkUpdate: LazyLoadedStates,
    addUser: LazyLoadedStates,
    user: LazyLoadedStates,
    editUser: LazyLoadedStates,
    onboarding: LazyLoadedStates
}> ({
    base: {
        name: 'authenticated.users',
        url: '/users',
        abstract: true
    },
    view: {
        name: 'authenticated.users.view',
        url: '/:page?orderBy&ascending',
    },
    viewSearch: {
        name: 'authenticated.users.view.search',
        url: '/search?searchBy&roleName',
        params: {
            searchBy: {
                raw: true,
                value: '',
            },
            roleName: {
                raw: true,
                value: ''
            }
        },
    },
    bulkUpdate: {
        name: 'authenticated.users.bulkupdate',
        url: '/bulkupdate',
    },
    addUser: {
        name: 'authenticated.users.add',
        url: '/add',
    },
    user: {
        name: 'authenticated.users.user',
        abstract: true,
        url: '/:userId',
    },
    editUser: {
        name: 'authenticated.users.user.edit',
        url: '/edit'
    },
    onboarding: {
        name: 'authenticated.users.onboarding',
        url: '/onboarding'
    }
},
() => import('src/app/users/users.module').then(mod => mod.UsersModule)
);
